<template>
  <div class="card currency-card">
    <div class="main-info">
      <div class="logo">
        <img :src="logo">
      </div>
      <div class="numbers">
        <div class="card-category">
          {{ title }}
        </div>
        <div class="card-title" :class="{loading: loading}">
          <template v-if="showInput">
            <div class="card-input-wrap">
              <fg-input
                ref="input"
                v-model="value"
                @created="handleInputCreated"
                @pressEnter="handleCLickAcceptIcon"/>
              <div class="card-toolbar">
                <div
                  class="icon"
                  @click="handleCLickAcceptIcon">
                  <i class="nc-icon nc-check-2"/>
                </div>
                <div
                  class="icon"
                  @click="handleClickCloseIcon">
                  <i class="nc-icon nc-simple-remove"/>
                </div>
              </div>
            </div>
          </template>
          <div
            v-else
            class="currency-rate"
            @click="handleRateClick">
            {{ data.value }}
          </div>
          <div class="currency-sign">
            ₽
          </div>
        </div>
      </div>
    </div>
    <div class="additional-info">
      <span v-if="loading">
        <el-icon class="is-loading">
          <Loading/>
        </el-icon>
        Обновление...
      </span>
      <span v-else-if="editable">Для редактирования кликните по значению</span>
    </div>
  </div>
</template>


<script>
import {AMOUNT_REGEXP} from "@/utils/regexp";
import {applyCurrencyFormat} from "@/utils/helpers";
import { mapActions } from 'vuex'

export default {
  name: "CurrencyCard",
  props: {
    data: Object,
    loading: Boolean,
    editable: Boolean,
  },
  data() {
    return {
      value: '',
      showInput: false,
      footerText: 'Применить',
      footerIcon: 'nc-icon nc-check-2',
    }
  },
  computed: {
    logo() {
      return `/static/img/flags/128/USD.png`
    },
    title() {
      return `Курс USD`
    },
  },
  watch: {
    value(newValue, oldValue) {
      if (newValue === '') return
      if (!String(newValue).match(AMOUNT_REGEXP)) {
        this.value = oldValue
      }
    }
  },
  methods: {
    ...mapActions(['updateRate']),
    handleRateClick() {
      if (this.loading || !this.editable) return
      this.showInput = true
    },
    handleInputCreated() {
      this.$refs['input'].onFocus()
    },
    handleClickCloseIcon() {
      this.showInput = false
      this.value = this.data.value
    },
    async handleCLickAcceptIcon() {
      if (!this.value || this.value === this.data.value) return
      this.showInput = false
      const value = applyCurrencyFormat(this.value).replace(/^0+/, '')
      this.$emit('startLoading', this.data.id)
      try {
        await this.updateRate({
          id: this.data.id,
          value,
        })
      } finally {
        this.$emit('finishLoading', this.data.id)
        this.value = this.data.value
      }
    }
  },
  beforeMount() {
    this.value = this.data.value
  }
}
</script>

<style scoped>

</style>
